import * as React from 'react';
import PropTypes from 'prop-types';
import Slide from '@mui/material/Slide';

import { ModalDialog } from 'catering/components/Modals';
import { callAll } from 'catering/helpers';

const Transition = React.forwardRef(function SlideTransition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ModalContext = React.createContext(null);
ModalContext.displayName = 'ModalContext';

function Modal({ initialIsOpen = false, ...rest }) {
  const [isOpen, setIsOpen] = React.useState(initialIsOpen);
  return <ModalContext.Provider value={[isOpen, setIsOpen]} {...rest} />;
}

Modal.propTypes = {
  initialIsOpen: PropTypes.bool
};

function useModalContext() {
  const context = React.useContext(ModalContext);
  if (!context) {
    throw new Error(`useModalContext must be used within a ModalContext`);
  }
  return context;
}

function ModalOpenButton({ children: child }) {
  const [, setIsOpen] = useModalContext();
  return React.cloneElement(child, {
    onClick: callAll(() => setIsOpen(true), child.props.onClick)
  });
}

function ModalDismissButton({ children: child }) {
  const [, setIsOpen] = useModalContext();
  return React.cloneElement(child, {
    onClick: callAll(() => setIsOpen(false), child.props.onClick)
  });
}

function ModalContentsBase({ fullScreen, onClose, ...rest }) {
  const [isOpen, setIsOpen] = useModalContext();

  const props = {
    TransitionComponent: fullScreen ? Transition : undefined,
    ...rest
  };

  return (
    <ModalDialog
      fullScreen={fullScreen}
      onClose={callAll(() => setIsOpen(false), onClose)}
      open={isOpen}
      {...props}
    />
  );
}

ModalContentsBase.propTypes = {
  fullScreen: PropTypes.bool,
  onClose: PropTypes.func
};

ModalContentsBase.defaultProps = {
  fullScreen: false
};

export {
  Modal,
  ModalContentsBase,
  ModalDismissButton,
  ModalOpenButton,
  useModalContext
};
